import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Kenzie from "./images/Kenzielog.png"
import Links from "./Links";

import "./Navbar.css";



class Navbar extends Component {
    render() {
        return (
            <nav className="navbar navbar-dark bg-warning">
                <div>
                    <img src={Kenzie} alt="Kenzie logo" />
                </div>
                <Links />
                <form className="form-inline my-2 my-lg-0" id="search">
                    <input className="form-control mr-sm-2" type="search" placeholder="Search" />
                    <button className="btn btn-outline-primary my-2 my-sm-0" type="submit">Search</button>
                </form>
            </nav>
        )
    };
}

export default Navbar
